import { getCart } from '@/apis/main';
import { useQuery } from '@tanstack/react-query';
import useApi from './useApi';
import { receivingType } from '@/types/checkout';

export const useCart = ({
  couponCode,
  receivingMethod = 'pick_up'
}: {
  couponCode?: string;
  receivingMethod?: receivingType;
}) => {
  const { fetchApi } = useApi();
  const { data: cartData } = useQuery({
    queryFn: () => fetchApi((accessToken) => getCart(accessToken, couponCode, receivingMethod)),
    queryKey: ['cart', couponCode, receivingMethod]
  });

  return { cartData };
};
